module.exports = __webpack_public_path__ + "fonts/EMprint-LightItalic.0b6f10ed.ttf";